import * as React from 'react';
const Menu = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 26 21"
		fill="none"
		{...props}
	>
		<path
			stroke="#03488E"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={4}
			d="M2.5 18.5h21m-21-8h21m-21-8h21"
		/>
	</svg>
);
export default Menu;
